import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {Focussable} from '../../../../components/common/focussable';

@Component({
    selector: 'app-input-text',
    templateUrl: './input-text.component.html',
    styles: [`
    /* Réduit la hauteur et la taille du texte dans le champ */
    :host ::ng-deep .mat-mdc-form-field {
      transform: scale(0.9);
      transform-origin: top left;
      width: 100%;
    }
    
    /* Optionnel : marge plus fine pour le compteur de caractères */
    :host ::ng-deep .text-right {
      margin-top: 2px;
      font-size: 0.7rem;
    }
  `]
})
export class InputTextComponent implements OnInit, Focussable, AfterViewInit {

    @Input() maxLength: number = undefined;
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() placeHolder: string;
    @Input() automaticFocus = false;
    @Input() type: 'text' | 'password' = 'text';
    @ViewChild('inputElement') inputElement!: ElementRef<HTMLInputElement>
    @Output() keyPressedEvent = new EventEmitter<string>();
    @Output() focussedEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() changedEvent = new EventEmitter<void>();

    constructor() {
    }


    ngOnInit() {
    }

    ngAfterViewInit(): void {
        if (this.automaticFocus) {
            this.focus();
        }
    }



    onKeyPressed(event) {
        this.keyPressedEvent?.emit(event);
    }

    focus() {
        this.inputElement?.nativeElement?.focus();
    }

    focussed(){
        this.focussedEvent.emit();
    }
}
